export default function deleteRow(event) {
  if (
      event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('table--detail__expanded')
    ) {
    event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(
        event.target.parentElement.parentElement.rowIndex + 1
      );
  }

  return event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(
    event.target.parentElement.parentElement.rowIndex
  );
}



// WEBPACK FOOTER //
// ./js/components/tables/actions/delete.js